import { PropsWithChildren } from 'react';
import { Col, Row } from 'react-bootstrap';

/** Componente Anchor para cambiar de modal entre login y nuevo usuario
 * @component
 */

type PropsTextAndLink = {
  /** Propiedad que define el texto del componente */
  text?: string;
  /** Propiedad que define la clase del texto del componente */
  classText?: string;
  /** Evento que se desencadena al clickear el link */
  onClick: () => void;
  /** Propiedad que define si los textos deben estar separados */
  separated?: boolean;
  /** Propiedad que define el texto del enlace */
  linkText?: string;
  classLinkButton?: string;
  /** Propiedad que define si el link está deshabilitado */
  disabled?: boolean;
};

const TextAndLink = ({
  text = '',
  classText,
  onClick,
  children,
  linkText,
  separated = true,
  classLinkButton,
  disabled = false,
}: PropsWithChildren<PropsTextAndLink>): JSX.Element => {
  /**Componente que renderiza texto y link separados y juntos segun sea la necesidad */
  return (
    <Row xs={12} className='align-items-center mt-auto py-2 d-flex'>
      {separated ? (
        <>
          <Col xs={7} className={classText}>
            <span>{text}</span>
          </Col>
          <Col xs={5} className={classText}>
            <span className='p-title-medium'>
              <button onClick={onClick} className='link-text-standard' disabled={disabled}>
                {children}
              </button>
            </span>
          </Col>
        </>
      ) : (
        <Col xs={12} className={classText}>
          <span className='p-regular-medium text-secondary-1 fw-bold paragraph '>
            {text}
            <button onClick={onClick} className={classLinkButton} disabled={disabled}>
              {linkText}
            </button>
          </span>
        </Col>
      )}
    </Row>
  );
};

export default TextAndLink;
